import React, { useState, useEffect, useRef } from "react";
import Table from "@mui/joy/Table";
import {PageHeader} from "../../Components/Header/PageHeader";
import { resources } from "../../Components/Resourses/Resources";
import axios from "axios";
import { useLocation } from "react-router-dom";
// import "../styleFaculty/styleDep.css";
import PaginationReUsable from "../../Components/ReuseableComponent/ReusePagination";
// import "../../Components/ReuseableComponent/ReusePagination.css";
import { getUserInfo } from "../../Components/Authservice";
import { Delete, EditIcon } from "lucide-react";
import SaveIcon from "@mui/icons-material/Save";
import CloseIcon from "@mui/icons-material/Close";
import DeleteIcon from "@mui/icons-material/Delete";
import Banner from "../../assets/Banner/Banner10.png";

import e from "cors";

// import "./faculty.css"

const FacultyEdit = () => {
  const userRole = getUserInfo()?.roles[0];
    const isAdmin = userRole === "ROLE_MANAGEMENT";
    const [facultyData, setfacultyData] = useState([]);
    const [allData, setAllData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [search, setSearch] = useState("");
    const [serialNo, setSerialNo] = useState("");
    const [paginationData, setPaginationData] = useState([]);
    const [editId, setEditId] = useState(null);
    const [activepopup, setActivepopup] = useState(false);
    const popUpRef = useRef(null);
    const [viewDocument, setViewDocument] = useState(null);
    const [isEnable, setIsEnable] = useState(false);
  
    const [facultyEditFields, setFacultyEditDetails] = useState({});
  
    const [newFaculty, setNewFaculty] = useState({
      faculty_name: "",
      designation: "",
      qualifications: "",
      dateOfJoin: "",
      facultyId: "",
      totalExperience: "",
    });
  
    const [photo, setphoto] = useState(null);
    const [document, setDocument] = useState(null);
    const [photourl, Setphotourl] = useState(null);
  
    const location = useLocation();
    const branchFaculty = location.pathname.split("/")[2]?.toUpperCase();
  
    const getfacul = async () => {
      axios
        .get(
          `${resources.APPLICATION_URL}get/All/Active/FacultyDetails`,
          {
            params: {
              department: branchFaculty,
            },
          }
        )
  
        .then((res) => {
          setfacultyData(res.data);
          console.log("initiallllll", res);
          getImages(res.data);
        })
        .catch((err) => {
          console.log(err);
        });
    };
  
    useEffect(() => {
      getfacul();
    }, []);
  
    useEffect(() => {
      setFilteredData(facultyData);
      setAllData(facultyData);
    }, [facultyData]);
  
    const handleGetSpliceData = (receivedList, startSNo) => {
      setPaginationData(receivedList);
      setSerialNo(startSNo);
    };
  
    const getImages = async (data) => {
      try {
        const updatedData = await Promise.all(
          data.map(async (each) => {
            try {
              const res = await axios.get(
                `${
                  resources.APPLICATION_URL
                }getFilePathtoConvertBase64?filePath=${encodeURIComponent(
                  each.photoPath
                )}`
              );
              return {
                ...each,
                photoPath: res.data, // base64 string
              };
            } catch (error) {
              console.log("Error fetching image for:", each.photoPath, error);
              return each;
            }
          })
        );
  
        return updatedData;
      } catch (error) {
        console.error("Failed to fetch images:", error);
        return data;
      }
    };
  
    const handleSearch = (e) => {
      const value = e.target.value.toLowerCase();
  
      const filterSearchData = allData.filter((each) => {
        return each?.faculty_name?.toLowerCase().includes(value);
      });
  
      console.log("Filtered Search ====>", filterSearchData);
  
      setSearch(e.target.value);
      // Optionally update the filtered data state:
      setFilteredData(filterSearchData);
    };
  
    const handleInputChange = (field, value) => {
      setNewFaculty({ ...newFaculty, [field]: value });
    };
    const base64ToBlobUrl = (base64String, mimeType) => {
      // If the string starts with "data:", strip it
      const base64 = base64String.includes("base64,")
        ? base64String.split("base64,")[1]
        : base64String;
  
      try {
        const byteCharacters = atob(base64); // Decode base64 to binary string
        const byteArrays = [];
  
        for (let i = 0; i < byteCharacters.length; i += 512) {
          const slice = byteCharacters.slice(i, i + 512);
          const byteNumbers = new Array(slice.length);
          for (let j = 0; j < slice.length; j++) {
            byteNumbers[j] = slice.charCodeAt(j);
          }
          byteArrays.push(new Uint8Array(byteNumbers));
        }
  
        const blob = new Blob(byteArrays, { type: mimeType });
        return URL.createObjectURL(blob);
      } catch (err) {
        console.error("Failed to convert base64 to blob:", err);
        return null;
      }
    };
  
    const handleEdit = async (id, each) => {
      console.log("Eachhhhhhh--------------->>>>>", each);
      console.log("Eachhhhhhh--------------->>>>>", id);
      setFacultyEditDetails(each);
      const row = facultyData.find((item) => item.sno === id);
      console.log(row);
      setNewFaculty(row);
      setEditId(row.sno);
      setIsEnable(true);
      Setphotourl(each.photoPath);
      // Setphotourl(each.photoPath);
  
      try {
        const resp = await axios.get(
          resources.APPLICATION_URL +
            `getFilePathtoConvertBase64?filePath=${encodeURIComponent(
              each.photoPath
            )}`
        );
        console.log("respppp", resp);
        Setphotourl(resp.data);
      } catch (error) {
        console.log("errrorrrr", error);
      }
  
      try {
        const resp = await axios.get(
          resources.APPLICATION_URL +
            `getFilePathtoConvertBase64?filePath=${encodeURIComponent(
              each.filePath
            )}`
        );
        const mimeType = each.filePath.endsWith(".pdf")
          ? "application/pdf"
          : "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
  
        const blobUrl = base64ToBlobUrl(resp.data, mimeType);
        setViewDocument(blobUrl);
      } catch (error) {
        console.log("errrorrrr", error);
      }
  
      // setactivepopup(true);
      // setActivepopup(true);
  
      // try{
      //   const editDetails = await axios.post(`${resources.APPLICATION_URL}/update/facultyDetails`)
      // }catch(e){
      //   console.log("error edit details",e)
      // }
    };
    const handleEditDataInputs = (e) => {
      const { name, value } = e;
      console.log("valuess of name=====>", name);
      console.log("valuesss of Value=====>", value);
    };
  
    const handleClose = () => {
      setEditId(null);
      setIsEnable(false);
    };
    // useEffect(() => {
    //   const handleClickOutside = (event) => {
    //     if (popUpRef.current && !popUpRef.current.contains(event.target)) {
    //       setActivepopup(false);
    //     }
    //   };
  
    //   if (activepopup) {
    //     document?.addEventListener("mousedown", handleClickOutside);
    //   }
  
    //   return () => {
    //     document?.removeEventListener("mousedown", handleClickOutside);
    //   };
    // }, [activepopup]);
  
    const handleSave = async (sno) => {
      let obj = { ...facultyEditFields };
      if (document) {
        obj = { ...obj, fileName: document.name };
      }
      if (photo) {
        obj = { ...obj, photoName: photo.name };
      }
      const jsonBlob = new Blob([JSON.stringify(obj)], {
        type: "application/json",
      });
      let formData = new FormData();
      formData.append("facultyDetails", jsonBlob);
      formData.append("files", photo);
      formData.append("files", document);
      console.log("Form Dataaaaa", formData);
  
      try {
        const response = await axios.put(
          `${resources.APPLICATION_URL}update/facultyDetails`,
          formData
        );
  
        console.log("Faculty updated:", response.data);
  
        // Update local state
        // setfacultyData((prev) =>
        //   prev.map((item) =>
        //     item.sno === sno ? { ...item, ...newFaculty } : item
        //   )
        // );
        getfacul();
        setEditId(null);
        setNewFaculty({
          faculty_name: "",
          designation: "",
          qualifications: "",
          dateOfJoin: "",
          facultyId: "",
          totalExperience: "",
        });
        // setActivepopup(false)
        // exit edit mode
      } catch (error) {
        console.error("Error while saving faculty details:", error);
      }
  
      console.log("errorrr");
      setIsEnable(false);
    };
  
    const handleFileUpload = (e) => {
      const file = e.target.files[0];
      if (file) {
        setDocument(file);
        const url = URL.createObjectURL(file);
        setViewDocument(url);
      }
    };
  
    const handleCancel = () => {
      // Clear edit mode without saving
      setEditId(null);
    };
    // alert(isAdmin)
    //   console.log("is Admin login====>",isAdmin)
  
    const handleDelete = async (sno) => {
      const confirmDelete = window.confirm(
        "Are you sure you want to delete this faculty?"
      );
      if (!confirmDelete) return;
  
      const facultyDetails = sno;
  
      try {
        const config = {
          data: {
            facultyDetails: {
              sno,
            },
          },
        };
  
        const response = await axios.post(
          `${resources.APPLICATION_URL}delete/facultyDetails`,
          facultyDetails
        );
        getfacul();
  
        console.log("Faculty deleted:", response.data);
  
        // Update UI
        setfacultyData((prev) => prev.filter((item) => item.sno !== sno));
      } catch (error) {
        console.error("Error deleting faculty:", error);
      }
    };
  
    const handleAddFaculty = async (e) => {
      e.preventDefault();
      try {
        const payload = { ...newFaculty, department: branchFaculty };
        const res = await axios.post(
          `${resources.APPLICATION_URL}saveFacultyDetails`,
          payload
        );
        console.log("Faculty Added:", res.data);
  
        // Update local state
        setfacultyData((prev) => [...prev, payload]);
  
        // Reset form
        setNewFaculty({
          faculty_name: "",
          designation: "",
          qualifications: "",
          dateOfJoin: "",
          facultyId: "",
          totalExperience: "",
        });
      } catch (error) {
        console.error("Error adding faculty:", error);
      }
    };
  
    const handleInputChange2 = (e) => {
      const { name, value } = e;
      console.log("eeeeeeeeeeee", name);
      console.log("valueeee", value);
    };
  
    return (
      <div>
         <img src={Banner} alt="Banner Sai Spurthi" style={{width:"100%"}}  />
      <div className="container">
        
        <PageHeader name="FACULTY" />
        {!isEnable && (
          <div>
            <h1 className="tableHeading">List of all {branchFaculty} faculty</h1>
  
            {/* Search */}
            <div className="saarchDiv">
              <input
                type="text"
                value={search}
                placeholder="Search By Name..."
                onChange={(e) => handleSearch(e)}
              />
            </div>
  
            {/* Table */}
            <Table className="Examtool_allinone_table" id="faccse">
              <thead style={{ backgroundColor: "#b3078d" }}>
                <tr>
                  <th>S.NO</th>
                  <th>Faculty Name</th>
                  <th>Designation</th>
                  <th>Qualification</th>
                  <th>Experience</th>
                  <th>Faculty Id</th>
                  {isAdmin && <th>Actions</th>}
                </tr>
              </thead>
              <tbody>
                {filteredData.length > 0 &&
                  filteredData.map((each, i) => {
                    const Sno = serialNo + i;
  
                    const dateOfJoin = each.dateOfJoin;
                    const currentDate = new Date();
  
                    let [joinDay, joinMonth, joinYear] = [
                      undefined,
                      undefined,
                      undefined,
                    ];
                    if (dateOfJoin && typeof dateOfJoin === "string") {
                      [joinDay, joinMonth, joinYear] = dateOfJoin
                        .split("-")
                        .map(Number);
                    }
  
                    const joinDate = new Date(joinYear, joinMonth - 1, joinDay);
                    const differenceMs = currentDate - joinDate;
  
                    const millisecondsInYear = 1000 * 60 * 60 * 24 * 365.25;
                    const experienceYears = Math.floor(
                      differenceMs / millisecondsInYear
                    );
                    const remainingMs = differenceMs % millisecondsInYear;
                    const millisecondsInMonth = millisecondsInYear / 12;
                    const experienceMonths = Math.floor(
                      remainingMs / millisecondsInMonth
                    );
  
                    const newExperience =
                      Number(each.totalExperience) +
                      experienceYears +
                      "Y-" +
                      experienceMonths +
                      "M";
  
                    return (
                      <tr key={i}>
                        <td>{Sno}</td>
  
                        <td>
                          {editId === each?.sno ? (
                            <input
                              type="text"
                              value={newFaculty.faculty_name}
                              onChange={(e) =>
                                setNewFaculty((prev) => ({
                                  ...prev,
                                  faculty_name: e.target.value,
                                }))
                              }
                            />
                          ) : (
                            each.faculty_name
                          )}
                        </td>
  
                        <td>
                          {editId === each?.sno ? (
                            <input
                              type="text"
                              value={newFaculty.designation}
                              onChange={(e) =>
                                setNewFaculty((prev) => ({
                                  ...prev,
                                  designation: e.target.value,
                                }))
                              }
                            />
                          ) : (
                            each.designation
                          )}
                        </td>
  
                        <td>
                          {editId === each?.sno ? (
                            <input
                              type="text"
                              value={newFaculty.qualifications}
                              onChange={(e) =>
                                setNewFaculty((prev) => ({
                                  ...prev,
                                  qualifications: e.target.value,
                                }))
                              }
                            />
                          ) : (
                            each.qualifications
                          )}
                        </td>
  
                        <td>
                          {editId === each?.sno ? (
                            <input
                              type="text"
                              value={newFaculty.totalExperience}
                              onChange={(e) =>
                                setNewFaculty((prev) => ({
                                  ...prev,
                                  totalExperience: e.target.value,
                                }))
                              }
                            />
                          ) : (
                            each.totalExperience
                          )}
                        </td>
  
                        <td>
                          {editId === each?.sno ? (
                            <input
                              type="text"
                              value={newFaculty.facultyId}
                              onChange={(e) =>
                                setNewFaculty((prev) => ({
                                  ...prev,
                                  facultyId: e.target.value,
                                }))
                              }
                            />
                          ) : (
                            each.facultyId
                          )}
                        </td>
  
                        {isAdmin && (
                          <td>
                            <>
                              <div
                                style={{
                                  display: "flex",
                                  gap: "10px",
                                  cursor: "pointer",
                                  justifyContent: "center",
                                }}
                              >
                                <EditIcon
                                  onClick={() => handleEdit(each.sno, each)}
                                />
                                <DeleteIcon
                                  color="error"
                                  onClick={() => handleDelete(each)}
                                />
                              </div>
                            </>
                          </td>
                        )}
                      </tr>
                    );
                  })}
              </tbody>
            </Table>
            {filteredData.length == 0 && (
              <span style={{ fontSize: "22px", textAlign: "center" }}>
                No Data Found
              </span>
            )}
  
            {/* Pagination */}
            <PaginationReUsable
              paginationData={filteredData}
              handleGetSpliceData={handleGetSpliceData}
            />
          </div>
        )}
  
        {isEnable && (
          <div
            className="active_popup_container"
            onClick={handleClose}
            ref={popUpRef}
          >
            <div
              className="active_popup_box"
              onClick={(e) => e.stopPropagation()}
            >
              <div style={{ display: "flex", justifyContent: "end" }}>
                <p className="popup_close_btn" onClick={handleClose}>
                  <CloseIcon className="CloseIcon_tab" />
                </p>
              </div>
              <h2 className="popup_title">Faculty Details</h2>
              <div className="popup_content">
                <div className="popup_image">
                  <img src={`data:image/png;base64,${photourl}`} alt={photourl} />
                </div>
                <div className="popup_fields">
                  {" "}
                  <div className="PopUp_Top_fields">
                    {" "}
                    {/* <div className="popup_field">
                      {" "}
                      <label>
                        <strong>S.No:</strong>
                      </label>{" "}
                      <input
                        type="text"
                        value={facultyEditFields.sno}
                        onChange={(e) =>
                          setFacultyEditDetails({
                            ...facultyEditFields,
                            sno: e.target.value,
                          })
                        }
                      />{" "}
                    </div>{" "} */}
                    <div className="popup_field">
                      {" "}
                      <label>
                        <strong>Faculty Name:</strong>
                      </label>{" "}
                      <input
                        type="text"
                        value={facultyEditFields.faculty_name}
                        onChange={(e) =>
                          setFacultyEditDetails({
                            ...facultyEditFields,
                            faculty_name: e.target.value,
                          })
                        }
                      />{" "}
                    </div>{" "}
                    <div className="popup_field">
                      {" "}
                      <label>
                        <strong>Designation:</strong>
                      </label>{" "}
                      <input
                        type="text"
                        value={facultyEditFields.designation}
                        onChange={(e) =>
                          setFacultyEditDetails({
                            ...facultyEditFields,
                            designation: e.target.value,
                          })
                        }
                      />{" "}
                    </div>{" "}
                    <div className="popup_field">
                      {" "}
                      <label>
                        <strong>Qualifications:</strong>
                      </label>{" "}
                      <input
                        type="text"
                        value={facultyEditFields.qualifications}
                        onChange={(e) =>
                          setFacultyEditDetails({
                            ...facultyEditFields,
                            qualifications: e.target.value,
                          })
                        }
                      />{" "}
                    </div>{" "}
                    <div className="popup_field">
                      {" "}
                      <label>
                        <strong>Total Experience:</strong>
                      </label>{" "}
                      <input
                        type="text"
                        value={facultyEditFields.totalExperience}
                        onChange={(e) =>
                          setFacultyEditDetails({
                            ...facultyEditFields,
                            totalExperience: e.target.value,
                          })
                        }
                      />{" "}
                    </div>{" "}
                    <div className="popup_field">
                      {" "}
                      <label>
                        <strong>Email:</strong>
                      </label>{" "}
                      <input
                        type="email"
                        value={facultyEditFields.email}
                        onChange={(e) =>
                          setFacultyEditDetails({
                            ...facultyEditFields,
                            email: e.target.value,
                          })
                        }
                      />{" "}
                    </div>{" "}
                    <div className="popup_field">
                      {" "}
                      <label>
                        <strong>Status:</strong>
                      </label>{" "}
                      <input
                        type="text"
                        value={facultyEditFields.status}
                        onChange={(e) =>
                          setFacultyEditDetails({
                            ...facultyEditFields,
                            status: e.target.value,
                          })
                        }
                      />{" "}
                    </div>{" "}
                  </div>{" "}
                  <div className="PopUp_Bottom_fields">
                    {" "}
                    <div className="popup_field">
                      {" "}
                      <label>
                        <strong>Phone Number:</strong>
                      </label>{" "}
                      <input
                        type="text"
                        value={facultyEditFields.phoneNumber}
                        onChange={(e) =>
                          setFacultyEditDetails({
                            ...facultyEditFields,
                            phoneNumber: e.target.value,
                          })
                        }
                      />{" "}
                    </div>{" "}
                    <div className="popup_field">
                      {" "}
                      <label>
                        <strong>Department:</strong>
                      </label>{" "}
                      <input
                        type="text"
                        value={facultyEditFields.department}
                        onChange={(e) =>
                          setFacultyEditDetails({
                            ...facultyEditFields,
                            department: e.target.value,
                          })
                        }
                      />{" "}
                    </div>{" "}
                    <div className="popup_field">
                      {" "}
                      <label>
                        <strong>Faculty ID:</strong>
                      </label>{" "}
                      <input
                        type="text"
                        value={facultyEditFields.facultyId}
                        onChange={(e) =>
                          setFacultyEditDetails({
                            ...facultyEditFields,
                            facultyId: e.target.value,
                          })
                        }
                      />{" "}
                    </div>{" "}
                    <div className="popup_field">
                      <label>
                        <strong>Date of Joining:</strong>
                      </label>
                      <input
                        type="text"
                        value={facultyEditFields.doj}
                        onChange={(e) =>
                          setFacultyEditDetails({
                            ...facultyEditFields,
                            doj: e.target.value,
                          })
                        }
                      />
                    </div>
                    <div className="popup_field">
                      <label>
                        <strong>Choose Faculty Photo:</strong>
                      </label>
                      <input
                        type="file"
                        accept="image/*"
                        onChange={(e) => setphoto(e.target.files[0])}
                      />
                    </div>
                    <div className="popup_field">
                      <>
                        <label>
                          <strong>Upload Faculty Document:</strong>
                        </label>
                        <input
                          type="file"
                          accept=".pdf,.doc,.docx"
                          onChange={handleFileUpload}
                        />
                      </>
                      {viewDocument && (
                        <a
                          href={viewDocument}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          View Document
                        </a>
                      )}
                    </div>
                    {/* {document && (
                      <a href={viewDocument} target="_blank">
                        view
                      </a>
                    )} */}
                  </div>{" "}
                </div>
              </div>
              {/* <button className="popup_close_btn" onClick={handleClose}>Close</button> */}
              {/* {editId === each?.sno && ( */}
              <>
                <div
                  style={{
                    display: "flex",
                    gap: "10px",
                    cursor: "pointer",
                    justifyContent: "center",
                  }}
                >
                  <button className="popup_save_btn" onClick={() => handleSave()}>
                    Modify
                  </button>
  
                  {/* <p onClick={handleCancel}><CloseIcon /></p> */}
                </div>
              </>
              {/* )} */}
            </div>
          </div>
        )}
  
        {/* )} */}
      </div>
      </div>
    );
};

export default FacultyEdit;
